type Box = Pick<DOMRect, 'left' | 'top' | 'width' | 'height'>;

export interface TooltipArrowShift {
  x: number;
  y: number;
}

// Half the arrow's base ($tooltip-arrow-size in _tooltip.scss) plus Material's 4px container
// corner radius. Keep in step with the SCSS, or the arrow overhangs a rounded corner.
const ARROW_EDGE_INSET = 10;

const getCentre = (start: number, size: number): number => start + size / 2;

const clampToPanel = (shift: number, panelSize: number): number => {
  const limit = Math.max(panelSize / 2 - ARROW_EDGE_INSET, 0);
  return Math.min(Math.max(shift, -limit), limit);
};

export const getTooltipArrowShift = (trigger: Box, panel: Box): TooltipArrowShift => ({
  x: clampToPanel(
    getCentre(trigger.left, trigger.width) - getCentre(panel.left, panel.width),
    panel.width
  ),
  y: clampToPanel(
    getCentre(trigger.top, trigger.height) - getCentre(panel.top, panel.height),
    panel.height
  ),
});
